import { QueryHookOptions, useQuery } from '@apollo/client';

import { GET_PROGRAM_ONBOARDING_TEMPLATE_BY_ID } from '@frontend/app/queries/GetProgramOnboardingTemplateById';
import {
  GetProgramOnboardingTemplateById,
  GetProgramOnboardingTemplateByIdVariables,
} from '@frontend/app/queries/types/GetProgramOnboardingTemplateById';

type IOptions = QueryHookOptions<GetProgramOnboardingTemplateById, GetProgramOnboardingTemplateByIdVariables>;

export const useGetProgramOnboardingTemplateById = (options: IOptions = {}) =>
  useQuery(GET_PROGRAM_ONBOARDING_TEMPLATE_BY_ID, options);
